<template>
    <div>
      <arksnackbar v-model="status" ></arksnackbar>
      <v-autocomplete
        hide-details
        append-icon="search"
        :label="label"
        :loading="status.loading"
        :items="items"
        item-text="id"
        item-value="id"
        :search-input.sync="search"
        v-model="Model"

        clearable=""

        :required="required"
        :rules="rules"


      >
      </v-autocomplete>
    </div>
</template>

<script>
import tool from '../tools'
import arksnackbar from '@/components/app/coper/comp/arksnackbar.vue'

export default {



    props:["value","apiname","label","tip","required","rules"],
    components: {
      arksnackbar,
    },
    computed: {
      Model: {
        get: function () {
          var r=""

          if ((this.value != undefined) && (this.value !=null))
          {
            r=this.value;
          }
          this.SetItems(r);
          return r;
        },
        set: function (newValue) {
          if (newValue==null){
            newValue="";
          }

          this.$emit('input', newValue )
        },
      },
    },

    data () {
      return {
        loading: false,
        items: [],
        search: null,
        status : tool.NewSatatus(),
        ayrac:"  -  ",
      }
    },

  watch: {
    search (val) {

        val && (val.length>=1) && this.querySelections(val)

    }
  },
  methods: {
    querySelections (v) {
      var prm={
          id:"",
          kod:"",
          aciklama:v,
          tip:this.tip
        };
        setTimeout(() => {
          this.Ara(prm);
        }, 500)
    },


    SetItems(v){
       if ((v!=null) && (v.length>0)){
          this.items=[v];
       } else{
         this.items=[];
       }
    },

    Ara(prm){

      this.status.loading=true;
      tool.http_post(this,this.apiname,prm).then((response) => {
        this.items=[];
        for (var i = 0; i < response.body.length; i++) {
            this.items.push(
                response.body[i].kod
              );
        }

        this.status.loading=false;
        }, (response) => {
          this.status = tool.responseToStatus(response);
      })
    }
  }
}

</script>